import { render } from "./MFAenhancedSecurity.vue?vue&type=template&id=200aabe0&scoped=true"
import script from "./MFAenhancedSecurity.vue?vue&type=script&lang=js"
export * from "./MFAenhancedSecurity.vue?vue&type=script&lang=js"

import "./MFAenhancedSecurity.vue?vue&type=style&index=0&id=200aabe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200aabe0"]])

export default __exports__